export default "__VITE_ASSET__fa0738ac__"